import {isNil} from 'lodash'
import {Nullish} from 'utility-types'
import {UserDownload} from '../../model'

export interface ProgressBarData {
  percentage: number
  estimatedTimeRemainingInMs: number
  bytesProcessed?: number
  bytesTotal?: number
}

export const getProgressBarData = (userDownload: UserDownload | Nullish): ProgressBarData => {
  let tabulatorProgress = 0
  let zipProgress = 0
  let bytesProcessed: number | undefined = undefined
  let bytesTotal: number | undefined = undefined
  if (userDownload?.progress?.zipProgress) {
    tabulatorProgress = 1
    const {completed, total} = userDownload.progress.zipProgress
    if (!isNil(completed)) {
      bytesProcessed = completed
    }
    if (!isNil(total)) {
      bytesTotal = total
    }
    if (completed && total) {
      zipProgress = completed / total
    }
  } else if (userDownload?.progress?.tabulatorProgress) {
    const {completed, total} = userDownload.progress.tabulatorProgress
    if (completed && total) {
      tabulatorProgress = completed / total
    }
  }
  const overallProgress = tabulatorProgress * 0.1 + zipProgress * 0.9
  const percentage = Math.round(overallProgress * 100)
  let estimatedTimeRemainingInMs = Infinity
  if (userDownload?.startedAt) {
    const startTimeInMs = userDownload.startedAt.getTime()
    estimatedTimeRemainingInMs = estimateRemainingTimeInMs(startTimeInMs, overallProgress)
  }
  return {
    percentage,
    estimatedTimeRemainingInMs,
    bytesProcessed,
    bytesTotal,
  }
}

export const estimateRemainingTimeInMs = (startTimeInMs: number, currentProgress: number): number => {
  if (currentProgress <= 0) return Infinity
  if (currentProgress >= 1) return 0
  const now = Date.now()
  const elapsed = now - startTimeInMs
  const estimatedTotalTime = elapsed / currentProgress
  return estimatedTotalTime - elapsed
}
